var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control"},[_c('div',{staticClass:"custom-input",class:_vm.space ? 'spaced' : 'not-spaced',style:({
      height: _vm.height,
      'min-height': _vm.minHeight,
      'max-height': _vm.maxHeight,
    })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }